const mistakes = [
  {
    icon: "ri-file-damage-line",
    title: "Wrong Photo Size or Quality",
    description: "Passport photos must be 2x2 inches with a white background and taken within the last 6 months. Most Anchorage photo shops can help — or ask your FPC agent.",
  },
  {
    icon: "ri-calendar-close-line",
    title: "Not Accounting for Alaska Shipping Time",
    description: "Overnight shipping from Anchorage to the lower 48 takes longer than the continental U.S. Factor in 1–2 extra days for shipping each direction when planning your timeline.",
  },
  {
    icon: "ri-user-unfollow-line",
    title: "Forgetting Both Parents for Child Applications",
    description: "Child passports under 16 require both parents or legal guardians present at the acceptance facility — or a notarized consent form if one parent can't attend.",
  },
  {
    icon: "ri-time-line",
    title: "Applying Too Late Before Travel",
    description: "Even expedited processing takes 2–9 days plus shipping time. For Alaska residents, apply at least 2 weeks before travel to be safe.",
  },
  {
    icon: "ri-draft-line",
    title: "Not Checking Passport Expiration Rules",
    description: "Many countries require 6 months of passport validity beyond your travel dates. Always verify the entry requirements for your specific destination.",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Confusing Anchorage Post Office Hours",
    description: "Acceptance facilities in Anchorage have varying hours and some require appointments. FPC pre-screens your eligibility so you only go in person when absolutely necessary.",
  },
];

export default function MistakesSection() {
  return (
    <section id="mistakes" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            6 Passport Mistakes Anchorage Applicants Make
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Avoid these common pitfalls that delay Anchorage passport applications — some of which are unique to Alaska&apos;s remote geography.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 mb-4">
                <i className={`${m.icon} text-red-500 text-lg`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{m.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{m.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}